import { CommonMessages } from '../../common.messages';

export const PanelPlansEditMessages = {
    GetPlanFailed: {
        key: 'GetPlanFailed',
        message: 'Can\'t load plan.'
    },
    UpdateStatusSucceed: {
        key: 'UpdateStatusSucceed',
        message: 'Update status succeed.'
    },
    UpdateStatusFailed: {
        key: 'UpdateStatusFailed',
        message: 'Update status failed.'
    },
    WrongPurchasePeriodDate: {
        key: 'WrongPurchasePeriodDate',
        message: 'Purchase Period End Date must be greater than Purchase Period Start Date'
    },
    WrongAccountActivationDate: {
        key: 'WrongAccountActivationDate',
        message: 'Deactivation Date  must be greater than Activation Date'
    },
    WrongPurchaseAndActivationDate: {
        key: 'WrongPurchaseAndActivationDate',
        message: 'Activation Date  must be greater than Purchase Period Start Date'
    },
    OverlappedPrizeGroup: {
        key: 'OverlappedPrizeGroup',
        message: 'Positions overlapped with other prize groups'
    },
    TotalPercentageExceeded: {
        key: 'TotalPercentageExceeded',
        message: 'Total percentage exceeded 100%'
    },
    PrizeGroupCreationFailed: {
        key: 'PrizeGroupCreationFailed',
        message: 'Error while processing request. Unable to create a Prize Group.'
    },
    PrizeGroupCreationSucceed: {
        key: 'PrizeGroupCreationSucceed',
        message: 'Prize Group is successfully created.'
    },
    PrizeGroupWinnerCountNotConfigured: {
        key: 'PrizeGroupWinnerCountNotConfigured',
        message: 'Prize Group winner count is not configured.'
    },
    ConsistencyCoefficientShouldBeLower: {
        key: 'ConsistencyCoefficientShouldBeLower',
        message: 'Lowest ConsistencyCoefficient must be lower than Consistency Coefficient.'
    },
    NotFoundExportData: {
        key: 'NotFoundExportData',
        message: 'Error while communication with the server. Can\'t find data to export.'
    },
    WrongReportFilterPeriodDate: {
        key: 'WrongReportFilterPeriodDate',
        message: 'Period To must be greater than Period From'
    },
    ...CommonMessages
};
